// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"783ee491","143":"6e8c1115","189":"45fdb490","237":"80b1cf81","350":"035e9acf","400":"67051f1e","736":"7b15f3e1","840":"f58a0e15"}[chunkId] + ".chunk.css";
};